import { Label } from '@/components/ui/label'
import { InstallationCountrySelect } from '@/features/installations/components/installation-country-select'

type NonEuCountrySelectProps = {
  label: string
  value: string
  onChange: (value: string) => void
  tooltip?: string
  disabled?: boolean
}

export function NonEuCountrySelect({
  label,
  value,
  onChange,
  tooltip,
  disabled,
}: NonEuCountrySelectProps) {
  return (
    <div className="grid gap-2">
      <Label title={tooltip}>{label}</Label>
      <InstallationCountrySelect
        value={value}
        onValueChange={(code) => {
          onChange(code.toLowerCase())
        }}
        placeholder={label}
        disabled={disabled}
      />
    </div>
  )
}
